/**
 * Summernote global configuration.
 *
 * Contains:
 * - toolbar structure
 * - popover configuration
 * - custom buttons registration
 *
 * This config is used during VueSummernote initialization
 * and represents a single source of truth for editor UI setup.
 *
 * Do not place runtime logic here.
 * This file should remain declarative only.
 */

import { AltTextButton } from './AltTextButton';

export const summernoteConfig = {
    /**
     * Enable fade animation for Summernote dialogs
     */
    dialogsFade: true,

    /**
     * Editor language
     */
    lang: "en-EN",

    /**
     * Default editor height
     */
    height: '200',

    /**
     * Main toolbar configuration
     */
    toolbar: [
        ['style', ['style']],
        ['font', ['bold', 'underline', 'clear', 'italic', 'strikethrough']],
        ['fontsize', ['fontsize']],
        ['color', ['color']],
        ['para', ['ul', 'ol', 'paragraph']],
        ['table', ['table']],
        ['insert', ['link', 'picture', 'video']],
        ['view', ['fullscreen', 'codeview', 'help']],
    ],

    /**
     * Context popovers configuration
     * (shown on image selection)
     */
    popover: {
        image: [
            ['image', ['resizeFull', 'resizeHalf', 'resizeThreeQuarter', 'resizeQuarter', 'resizeNone']],
            ['float', ['floatLeft', 'floatRight', 'floatNone']],
            ['remove', ['removeMedia']],
            ['custom', ['altTextButton']],
        ],
    },

    /**
     * Custom Summernote buttons registry
     */
    buttons: {
        altTextButton: AltTextButton
    }
};
